"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectorNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_SELECTOR
 * @param {object} fields
 * @returns
 */
const selectorNormalizer = (data) => {
    var _a;
    try {
        const res = {};
        const selectoresMain = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.selectoresMain;
        if (selectoresMain &&
            Array.isArray(selectoresMain) &&
            selectoresMain.length > 0) {
            selectoresMain.forEach((sel, index) => {
                const multiSelector = {};
                const { fields } = sel;
                const preTitle = fields.description || "";
                const title = fields.nameSelector || "";
                const buttonTitle = fields.labelText || "";
                const selected = fields.selected === "true" || "";
                const url = fields.url || "";
                const selectoresList = fields.selectoresList;
                let primaryAlias = "";
                if (preTitle) {
                    multiSelector["Text-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: preTitle });
                }
                if (title) {
                    multiSelector["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
                }
                if (selectoresList &&
                    Array.isArray(selectoresList) &&
                    selectoresList.length > 0) {
                    selectoresList.forEach((single, index) => {
                        const singleSelect = {};
                        const { fields } = single;
                        const preTitle = fields.description || "";
                        const title = fields.nameSelector || "";
                        const selected = fields.selected === "true" || "";
                        const url = fields.urlpage || "";
                        const orionAlias = fields.aliaspage || "";
                        const button = fields.labelText || "";
                        if (selected) {
                            primaryAlias = orionAlias;
                        }
                        if (preTitle) {
                            singleSelect["Text-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), { text: preTitle });
                        }
                        if (title) {
                            singleSelect["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
                        }
                        if (button) {
                            singleSelect["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button"]), { label: button, selected: selected });
                        }
                        multiSelector[`Select-${index + 1}`] = Object.assign({ selected: selected, url,
                            orionAlias }, singleSelect);
                    });
                }
                const primaryButton = Object.assign(Object.assign({}, mocks_json_1.default["Button"]), { label: buttonTitle, selected: selected, orionAlias: primaryAlias });
                res[`Multi-Select-${index + 1}`] = Object.assign({ selected: selected, url, "Button-1": primaryButton }, multiSelector);
            });
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.selectorNormalizer = selectorNormalizer;
exports.default = exports.selectorNormalizer;
//# sourceMappingURL=index.js.map